import React from 'react'

import { PortfolioSecurityAllocation } from 'generated/types'
import { PreviewPortfolioContainer } from 'pages/PortfolioTheme/preview-portfolio/styled-components'

import ETFItem from './ETFItem'
import {
  EtfListContainer,
  EtfListHeaderContainer,
  EtfListHeaderEtfCount,
  EtfListHeaderTitle,
} from './styled-components'

type Props = {
  etfs: PortfolioSecurityAllocation[]
  selectedIndex: number
}

export default (props: Props) => (
  <PreviewPortfolioContainer>
    <EtfListHeaderContainer>
      <EtfListHeaderTitle>Your investments</EtfListHeaderTitle>
      <EtfListHeaderEtfCount>{props.etfs.length} ETFs</EtfListHeaderEtfCount>
    </EtfListHeaderContainer>
    <EtfListContainer>
      {props.etfs.map((item, index) => (
        <ETFItem
          etf={item}
          key={item.symbol}
          disabled={props.selectedIndex !== null && props.selectedIndex !== index}
        />
      ))}
    </EtfListContainer>
  </PreviewPortfolioContainer>
)
